import api from "../../utils/api";
import { handleApiError } from "../../utils/errors";

export const getUserProfile = async (userId) => {
  try {
    const response = await api.get(`/user-profile/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw handleApiError(error, "user profile");
  }
};

export const createProfile = async (profileData) => {
  try {
    const payload = {
      favouriteTeamId: profileData.favouriteTeam,
      displayName: profileData.displayName,
      notificationsEnabled: profileData.notificationsEnabled ?? true,
      notificationType: profileData.notificationType || "hours_before",
      notificationValue: profileData.notificationValue || "4",
      notificationMethod: profileData.notificationMethod || "email",
      timezone: profileData.timezone,
    };
    const response = await api.post(`/user-profile`, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating user profile:", error);
    throw handleApiError(error, "user profile");
  }
};

export const updateProfile = async (updatedProfile, userId) => {
  try {
    const payload = {
      favouriteTeamId: updatedProfile.favouriteTeam,
      displayName: updatedProfile.displayName,
      notificationsEnabled: updatedProfile.notificationsEnabled ?? true,
      notificationType: updatedProfile.notificationType || "hours_before",
      notificationValue: updatedProfile.notificationValue || "4",
      notificationMethod: updatedProfile.notificationMethod || "email",
      timezone: updatedProfile.timezone,
    };
    const response = await api.put(`/user-profile/${userId}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating user profile:", error);
    throw handleApiError(error, "user profile");
  }
};

// Smart upsert function that decides between create and update
export const upsertProfile = async (profileData, userId) => {
  // Without a userId the lookup below hits /user-profile/undefined, finds
  // nothing, and falls through to createProfile — which would overwrite an
  // existing profile (and reset its createdAt, dropping the user out of
  // Last Man Standing). Fail loudly instead.
  if (!userId) {
    throw new Error("upsertProfile requires a userId");
  }
  try {
    const existingProfile = await getUserProfile(userId);
    if (existingProfile && existingProfile.userId) {
      return await updateProfile(profileData, userId);
    } else {
      return await createProfile(profileData);
    }
  } catch (error) {
    if (error.response?.status === 404 || error.message?.includes("null")) {
      return await createProfile(profileData);
    }
    throw error;
  }
};
